import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Landing() {
    const [BookFromData, setBookFromData] = useState({
        action: 'DemonstrationSubmit',
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: '',
        inputMessage: '',
        type: 'contact'
    });

    const [BookFromErrors, setBookFromErrors] = useState({
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: '',
        inputMessage: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBookFromData(prevState => ({
            ...prevState,
            [name]: value
        }));

        // Clear error when user starts typing
        if (BookFromErrors[name]) {
            setBookFromErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!BookFromData.inputFullName.trim()) {
            errors.inputFullName = 'Full Name is required';
            isValid = false;
        }

        if (!BookFromData.inputNumber.trim()) {
            errors.inputNumber = 'Contact Number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(BookFromData.inputNumber.replace(/\D/g, ''))) {
            errors.inputNumber = 'Please enter a valid 10-digit phone number';
            isValid = false;
        }

        if (!BookFromData.inputEmail.trim()) {
            errors.inputEmail = 'Email Address is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(BookFromData.inputEmail)) {
            errors.inputEmail = 'Please enter a valid email address';
            isValid = false;
        }

        if (!BookFromData.inputCity.trim()) {
            errors.inputCity = 'City is required';
            isValid = false;
        }
         if (!BookFromData.inputMessage.trim()) {
            errors.inputMessage = 'Message is required';
            isValid = false;
        }

        setBookFromErrors(errors);
        return isValid;
    };

    const BookhandleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            // toast.error('Please fill all required fields correctly');
            return false;
        }

        setIsSubmitting(true);
        
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, BookFromData);

            if (response.data.status === true) {
                toast.success(response.data.message);
                setBookFromData({
                    action: 'DemonstrationSubmit',
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: '',
                    inputMessage: '',
                    type: 'contact'
                    
                });
                setBookFromErrors({
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: '',
                    inputMessage: ''
                });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('An error occurred. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <ToastContainer />
            
            {/* Add CSS for floating labels */}
            <style>{`
                .form-group-floating {
                    position: relative;
                    margin-bottom: 1.5rem;
                }
                
                .form-group-floating input,
                .form-group-floating textarea {
                    padding-top: 1.5rem;
                    padding-bottom: 0.5rem;
                    height: auto;
                    width: 100%;
                }
                
                .form-group-floating .floating-label {
                    position: absolute;
                    top: 0.75rem;
                    left: 0.75rem;
                    font-size: 0.875rem;
                    color: #6b7280;
                    transition: all 0.2s ease-in-out;
                    pointer-events: none;
                    background: white;
                    padding: 0 0.25rem;
                    margin-left: -0.25rem;
                    z-index: 1;
                }
                
                .form-group-floating input:focus ~ .floating-label,
                .form-group-floating input:not(:placeholder-shown) ~ .floating-label,
                .form-group-floating textarea:focus ~ .floating-label,
                .form-group-floating textarea:not(:placeholder-shown) ~ .floating-label {
                    top: -0.5rem;
                    left: 0.5rem;
                    font-size: 0.75rem;
                    color: #1c1c1dff;
                }
                
                .error-message {
                    color: #dc2626;
                    font-size: 0.875rem;
                    margin-top: 0.25rem;
                    display: block;
                }
                
                .wpcf7-form-control.error {
                    border-color: #dc2626;
                }
                
                .btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
                
                .btn:disabled .icon {
                    opacity: 0.6;
                }
            `}</style>

            <section className="section section--masthead basic">
                <div className="container">
                    <div className="breadcrumbs">
                        <ol itemScope="" itemType="https://schema.org/BreadcrumbList">
                            <li className="crumb" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <a itemProp="item" href={`${process.env.REACT_APP_APP_URL}`}>
                                    <span itemProp="name">Home</span>
                                </a>
                                <meta itemProp="position" content="1" />
                            </li>
                            <li className="crumb crumb-3" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <span itemProp="item">
                                    <span itemProp="name">
                                        <strong>Contact Us</strong>
                                    </span>
                                </span>
                                <meta itemProp="position" content="2" />
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section className="section section--contact">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="wysiwyg address">
                                <h3><strong>Middleby Celfrost</strong></h3>
                                <p>
                                    <strong>Head Office</strong><br />
                                    Unit No. 713-716 , 7th Floor,<br />
                                    JMD Megapolis, Sector-48,<br />
                                    Sohna Road, Gurugram - 122018, Haryana
                                </p>
                                <p>
                                    <a href="assets/img/Map.jpg" target="_blank">
                                        <strong>Brand Center / Authorised Dealers</strong><br />
                                        <img src={`${process.env.REACT_APP_API_URL}assets/img/Map.jpg`} width="200" />
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row gx-5 gy-4">
                                <div className="wysiwyg form">
                                    <h3><strong>How can we help?</strong></h3>
                                    <div className="wpcf7 js" id="wpcf7-f248-o1" lang="en-GB" dir="ltr">
                                        <div className="screen-reader-response">
                                            <p role="status" aria-live="polite" aria-atomic="true"></p>
                                            <ul></ul>
                                        </div>
                                        <form onSubmit={BookhandleSubmit} method="post" className="wpcf7-form init" aria-label="Contact form" noValidate="novalidate" data-status="init">
                                            {/* Full Name */}
                                            <div className="form-group-floating">
                                                <p>
                                                    <input
                                                        onChange={handleChange}
                                                        size="40"
                                                        className={`wpcf7-form-control wpcf7-text wpcf7-validates-as-required ${BookFromErrors.inputFullName ? 'error' : ''}`}
                                                        id="inputFullName"
                                                        aria-required="true"
                                                        aria-invalid="false"
                                                        value={BookFromData.inputFullName}
                                                        type="text"
                                                        name="inputFullName"
                                                        placeholder=" "
                                                    />
                                                    <label className="floating-label" htmlFor="inputFullName">Full Name*</label>
                                                    {BookFromErrors.inputFullName && <span className="error-message">{BookFromErrors.inputFullName}</span>}
                                                </p>
                                            </div>

                                            {/* Contact Number */}
                                            <div className="form-group-floating">
                                                <p>
                                                    <input
                                                        onChange={handleChange}
                                                        size="40"
                                                        className={`wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel ${BookFromErrors.inputNumber ? 'error' : ''}`}
                                                        id="inputNumber"
                                                        aria-required="true"
                                                        aria-invalid="false"
                                                        value={BookFromData.inputNumber}
                                                        type="tel"
                                                        name="inputNumber"
                                                        placeholder=" "
                                                        maxLength={10}
                                                    />
                                                    <label className="floating-label" htmlFor="inputNumber">Contact Number*</label>
                                                    {BookFromErrors.inputNumber && <span className="error-message">{BookFromErrors.inputNumber}</span>}
                                                </p>
                                            </div>

                                            {/* Email Address */}
                                            <div className="form-group-floating">
                                                <p>
                                                    <input
                                                        onChange={handleChange}
                                                        size="40"
                                                        className={`wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email ${BookFromErrors.inputEmail ? 'error' : ''}`}
                                                        id="inputEmail"
                                                        aria-required="true"
                                                        aria-invalid="false"
                                                        value={BookFromData.inputEmail}
                                                        type="email"
                                                        name="inputEmail"
                                                        placeholder=" "
                                                    />
                                                    <label className="floating-label" htmlFor="inputEmail">Email Address*</label>
                                                    {BookFromErrors.inputEmail && <span className="error-message">{BookFromErrors.inputEmail}</span>}
                                                </p>
                                            </div>

                                            {/* City */}
                                            <div className="form-group-floating">
                                                <p>
                                                    <input
                                                        onChange={handleChange}
                                                        size="40"
                                                        className={`wpcf7-form-control wpcf7-text ${BookFromErrors.inputCity ? 'error' : ''}`}
                                                        id="inputCity"
                                                        aria-required="true"
                                                        aria-invalid="false"
                                                        value={BookFromData.inputCity}
                                                        type="text"
                                                        name="inputCity"
                                                        placeholder=" "
                                                    />
                                                    <label className="floating-label" htmlFor="inputCity">City*</label>
                                                    {BookFromErrors.inputCity && <span className="error-message">{BookFromErrors.inputCity}</span>}
                                                </p>
                                            </div>

                                            {/* How can we help */}
                                            <div className="form-group-floating">
                                                <p>
                                                    <textarea
                                                        onChange={handleChange}
                                                        cols="40"
                                                        rows="10"
                                                        className={`wpcf7-form-control wpcf7-textarea ${BookFromErrors.inputMessage ? 'error' : ''}`}
                                                        id="inputMessage"
                                                        aria-invalid="false"
                                                        name="inputMessage"
                                                        value={BookFromData.inputMessage}
                                                        placeholder=" "
                                                    ></textarea>
                                                    <label className="floating-label" htmlFor="inputMessage">How can we help?</label>
                                                    {BookFromErrors.inputMessage && <span className="error-message">{BookFromErrors.inputMessage}</span>}
                                                </p>
                                            </div>

                                            <div className="row mt-4">
                                                <div className="col">
                                                    <p>*Required</p>
                                                </div>
                                                <div className="col-5">
                                                    <p>
                                                        <button 
                                                            className="btn btn--block" 
                                                            type="submit"
                                                            disabled={isSubmitting}
                                                        >
                                                            <span>{isSubmitting ? 'Sending...' : 'Send'}</span>
                                                            <span className="icon" style={{ height: '13px' }}>
                                                                <i className="fas fa-chevron-right"></i>
                                                            </span>
                                                        </button>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="wpcf7-response-output" aria-hidden="true"></div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section section--map">
                <div className="section--map__top">
                    <div className="container">
                        <h2>
                            <span>HOW TO <strong>FIND US</strong></span>
                            <span className="icon"></span>
                        </h2>
                    </div>
                </div>
                <div className="section--map__bottom">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.0016855624344!2d77.03644931425394!3d28.419206000456498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d18edf65a0135%3A0xc0cabebd7592b9a2!2sMiddleby%20Celfrost%20Innovations%20Pvt.Ltd.!5e0!3m2!1sen!2sin!4v1669707237442!5m2!1sen!2sin" width="600" height="450" style={{ border: '0' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </section>
        </>
    )
}
